import HomeBanner1 from "../ones/HomeBanner1";
import CallToAction from "../ones/callToAction";
import Footer from "../ones/Footer";
import HomeLegalStatus from "../ones/HomeLegalStatus";
import HomeProjectSection from "../ones/HomeProjectSection";
import HomeServicesContent from "../ones/HomeServicesContent";
import HomeTeamSection from "../ones/HomeTeamSection";

export default function HomeLanding() {
  return (
    <>
      <HomeBanner1 />
      <HomeServicesContent />
      <HomeProjectSection />
      <HomeTeamSection />
      <HomeLegalStatus />
      <CallToAction />
      <Footer />
    </>
  );
}
